import type { RouteRecordRaw, Router } from 'vue-router'

const PeaceContractRoutes: RouteRecordRaw = {
  path: '/contract/estate/peace',
  name: 'EstatePeaceModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'EstatePeaceMainRoute',
      component: () => import('./views/AccordView.vue'),
      meta: {
        title: 'peaceEstate.peaceContract',
      },
    },
    {
      path: 'create',
      name: 'EstatePeaceCreateRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'peaceEstate.createPeaceContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:accordId',
      name: 'EstatePeaceEditRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'peaceEstate.editPeaceContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:accordId',
      name: 'ViewEstatePeaceRoute',
      component: () => import('./views/SingleAccordView.vue'),
      meta: {
        title: 'peaceEstate.ViewPeace',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(PeaceContractRoutes)
}
